/**
 * ManageChannels – SVG icon.
 */
import Screen from '@screen';

export default function ManageChannelsIcon({
  width,
  height,
  margin,
}: {
  width?: number;
  height?: number;
  margin?: string;
}) {
  return (
    <svg
      width={(width ? width : 78) * Screen.widthRatio}
      height={(height ? height : 85) * Screen.widthRatio}
      viewBox='0 0 78 85'
      style={{ margin: margin ? margin : 0 }}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M71.9965 82.4889H51.9942C49.794 82.4889 47.9938 80.6887 47.9938 78.4885V26.4826C47.9938 24.2824 49.794 22.4822 51.9942 22.4822H71.9965C74.1967 22.4822 75.9969 24.2824 75.9969 26.4826V78.4885C75.9969 80.6887 74.1967 82.4889 71.9965 82.4889Z'
        stroke='url(#paint0_linear_settings_manageChannels)'
        strokeWidth='3.76513'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M61.9982 64.4873V62.4871'
        stroke='url(#paint1_linear_settings_manageChannels)'
        strokeWidth='3.76513'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M61.9982 74.4877V72.4874'
        stroke='url(#paint2_linear_settings_manageChannels)'
        strokeWidth='3.76513'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M57.9978 68.4877H55.9976'
        stroke='url(#paint3_linear_settings_manageChannels)'
        strokeWidth='3.76513'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M67.9961 68.4877H65.9958'
        stroke='url(#paint4_linear_settings_manageChannels)'
        strokeWidth='3.76513'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M57.9978 54.4854H55.9976'
        stroke='url(#paint5_linear_settings_manageChannels)'
        strokeWidth='3.76513'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M67.9961 54.4854H65.9958'
        stroke='url(#paint6_linear_settings_manageChannels)'
        strokeWidth='3.76513'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M55.9945 36.3663C56.0594 36.3663 56.1126 36.4186 56.1127 36.4835C56.1127 36.5485 56.0595 36.6017 55.9945 36.6017C55.9296 36.6016 55.8773 36.5484 55.8773 36.4835C55.8774 36.4187 55.9297 36.3665 55.9945 36.3663Z'
        fill='url(#paint7_linear_settings_manageChannels)'
        stroke='url(#paint8_linear_settings_manageChannels)'
        strokeWidth='3.76513'
      />
      <path
        d='M55.9945 30.3657C56.0594 30.3657 56.1126 30.418 56.1127 30.4829C56.1127 30.5479 56.0595 30.6011 55.9945 30.6011C55.9296 30.601 55.8773 30.5478 55.8773 30.4829C55.8774 30.4181 55.9297 30.3658 55.9945 30.3657Z'
        fill='url(#paint9_linear_settings_manageChannels)'
        stroke='url(#paint10_linear_settings_manageChannels)'
        strokeWidth='3.76513'
      />
      <path
        d='M61.9951 36.3663C62.06 36.3663 62.1132 36.4186 62.1133 36.4835C62.1133 36.5485 62.0601 36.6017 61.9951 36.6017C61.9302 36.6016 61.8779 36.5484 61.8779 36.4835C61.8781 36.4187 61.9303 36.3665 61.9951 36.3663Z'
        fill='url(#paint11_linear_settings_manageChannels)'
        stroke='url(#paint12_linear_settings_manageChannels)'
        strokeWidth='3.76513'
      />
      <path
        d='M67.9958 36.3663C68.0608 36.3663 68.1139 36.4186 68.114 36.4835C68.114 36.5485 68.0608 36.6017 67.9958 36.6017C67.931 36.6016 67.8787 36.5484 67.8787 36.4835C67.8788 36.4187 67.931 36.3665 67.9958 36.3663Z'
        fill='url(#paint13_linear_settings_manageChannels)'
        stroke='url(#paint14_linear_settings_manageChannels)'
        strokeWidth='3.76513'
      />
      <path
        d='M55.9945 42.3671C56.0594 42.3671 56.1126 42.4194 56.1127 42.4843C56.1127 42.5492 56.0595 42.6024 55.9945 42.6024C55.9296 42.6023 55.8773 42.5492 55.8773 42.4843C55.8774 42.4194 55.9297 42.3672 55.9945 42.3671Z'
        fill='url(#paint15_linear_settings_manageChannels)'
        stroke='url(#paint16_linear_settings_manageChannels)'
        strokeWidth='3.76513'
      />
      <path
        d='M61.9951 42.3671C62.06 42.3671 62.1132 42.4194 62.1133 42.4843C62.1133 42.5492 62.0601 42.6024 61.9951 42.6024C61.9302 42.6023 61.8779 42.5492 61.8779 42.4843C61.8781 42.4194 61.9303 42.3672 61.9951 42.3671Z'
        fill='url(#paint17_linear_settings_manageChannels)'
        stroke='url(#paint18_linear_settings_manageChannels)'
        strokeWidth='3.76513'
      />
      <path
        d='M67.9958 42.3671C68.0608 42.3671 68.1139 42.4194 68.114 42.4843C68.114 42.5492 68.0608 42.6024 67.9958 42.6024C67.931 42.6023 67.8787 42.5492 67.8787 42.4843C67.8788 42.4194 67.931 42.3672 67.9958 42.3671Z'
        fill='url(#paint19_linear_settings_manageChannels)'
        stroke='url(#paint20_linear_settings_manageChannels)'
        strokeWidth='3.76513'
      />
      <path
        d='M55.9945 48.3677C56.0594 48.3677 56.1126 48.42 56.1127 48.4849C56.1127 48.5498 56.0595 48.603 55.9945 48.603C55.9296 48.6029 55.8773 48.5498 55.8773 48.4849C55.8774 48.4201 55.9297 48.3678 55.9945 48.3677Z'
        fill='url(#paint21_linear_settings_manageChannels)'
        stroke='url(#paint22_linear_settings_manageChannels)'
        strokeWidth='3.76513'
      />
      <path
        d='M61.9951 48.3677C62.06 48.3677 62.1132 48.42 62.1133 48.4849C62.1133 48.5498 62.0601 48.603 61.9951 48.603C61.9302 48.6029 61.8779 48.5498 61.8779 48.4849C61.8781 48.4201 61.9303 48.3678 61.9951 48.3677Z'
        fill='url(#paint23_linear_settings_manageChannels)'
        stroke='url(#paint24_linear_settings_manageChannels)'
        strokeWidth='3.76513'
      />
      <path
        d='M67.9958 48.3677C68.0608 48.3677 68.1139 48.42 68.114 48.4849C68.114 48.5498 68.0608 48.603 67.9958 48.603C67.931 48.6029 67.8787 48.5498 67.8787 48.4849C67.8788 48.4201 67.931 48.3678 67.9958 48.3677Z'
        fill='url(#paint25_linear_settings_manageChannels)'
        stroke='url(#paint26_linear_settings_manageChannels)'
        strokeWidth='3.76513'
      />
      <path
        d='M14.6292 6.32623C13.5375 6.32623 12.6522 7.21127 12.6522 8.3032C12.6522 10.7014 10.7011 12.6525 8.30296 12.6525C5.90479 12.6525 3.95371 10.7014 3.95371 8.3032C3.95371 5.90504 5.90479 3.95395 8.30296 3.95395C9.39465 3.95395 10.2799 3.06891 10.2799 1.97698C10.2799 0.88504 9.39489 0 8.30296 0C3.72462 0 0 3.72486 0 8.30296C0 12.881 3.72486 16.6059 8.30296 16.6059C12.881 16.6059 16.6059 12.881 16.6059 8.30296C16.6062 7.21127 15.7209 6.32623 14.6292 6.32623Z'
        fill='url(#paint27_linear_settings_manageChannels)'
      />
      <path
        d='M14.6292 29.5256C13.5375 29.5256 12.6522 30.4106 12.6522 31.5025C12.6522 33.9007 10.7011 35.8518 8.30296 35.8518C5.90479 35.8518 3.95371 33.9007 3.95371 31.5025C3.95371 29.1044 5.90479 27.1533 8.30296 27.1533C9.39465 27.1533 10.2799 26.2683 10.2799 25.1763C10.2799 24.0844 9.39489 23.1993 8.30296 23.1993C3.72462 23.1993 0 26.9242 0 31.5023C0 36.0804 3.72486 39.8053 8.30296 39.8053C12.881 39.8053 16.6059 36.0804 16.6059 31.5023C16.6062 30.4109 15.7209 29.5256 14.6292 29.5256Z'
        fill='url(#paint28_linear_settings_manageChannels)'
      />
      <path
        d='M37.8188 33.7394H23.0579C21.9662 33.7394 21.0809 34.6244 21.0809 35.7164C21.0809 36.8083 21.966 37.6933 23.0579 37.6933H37.8188C38.9105 37.6933 39.7958 36.8083 39.7958 35.7164C39.7958 34.6244 38.9107 33.7394 37.8188 33.7394Z'
        fill='url(#paint29_linear_settings_manageChannels)'
      />
      <path
        d='M37.8188 25.3083H23.0579C21.9662 25.3083 21.0809 26.1934 21.0809 27.2853C21.0809 28.3773 21.966 29.2623 23.0579 29.2623H37.8188C38.9105 29.2623 39.7958 28.3773 39.7958 27.2853C39.7958 26.1934 38.9107 25.3083 37.8188 25.3083Z'
        fill='url(#paint30_linear_settings_manageChannels)'
      />
      <path
        d='M33.6015 56.9364H23.0579C21.9662 56.9364 21.0809 57.8214 21.0809 58.9134C21.0809 60.0053 21.966 60.8904 23.0579 60.8904H33.6015C34.6931 60.8904 35.5784 60.0053 35.5784 58.9134C35.5784 57.8214 34.6931 56.9364 33.6015 56.9364Z'
        fill='url(#paint31_linear_settings_manageChannels)'
      />
      <path
        d='M37.8188 48.5005H23.0579C21.9662 48.5005 21.0809 49.3855 21.0809 50.4775C21.0809 51.5694 21.966 52.4544 23.0579 52.4544H37.8188C38.9105 52.4544 39.7958 51.5694 39.7958 50.4775C39.7958 49.3855 38.9107 48.5005 37.8188 48.5005Z'
        fill='url(#paint32_linear_settings_manageChannels)'
      />
      <path
        d='M56.7972 10.5448H23.0579C21.9662 10.5448 21.0809 11.4298 21.0809 12.5218C21.0809 13.6137 21.966 14.4988 23.0579 14.4988H56.797C57.8886 14.4988 58.7739 13.6137 58.7739 12.5218C58.7739 11.4298 57.8889 10.5448 56.7972 10.5448Z'
        fill='url(#paint33_linear_settings_manageChannels)'
      />
      <path
        d='M48.3623 2.11011H23.0579C21.9662 2.11011 21.0809 2.99515 21.0809 4.08708C21.0809 5.17902 21.966 6.06406 23.0579 6.06406H48.3623C49.454 6.06406 50.3393 5.17902 50.3393 4.08708C50.3393 2.99515 49.4543 2.11011 48.3623 2.11011Z'
        fill='url(#paint34_linear_settings_manageChannels)'
      />
      <path
        d='M14.6292 52.7166C13.5375 52.7166 12.6522 53.6017 12.6522 54.6936C12.6522 57.0918 10.7011 59.0428 8.30296 59.0428C5.90479 59.0428 3.95371 57.0918 3.95371 54.6936C3.95371 52.2954 5.90479 50.3443 8.30296 50.3443C9.39465 50.3443 10.2799 49.4593 10.2799 48.3674C10.2799 47.2754 9.39489 46.3904 8.30296 46.3904C3.72462 46.3904 0 50.1152 0 54.6933C0 59.2714 3.72486 62.9963 8.30296 62.9963C12.881 62.9963 16.6059 59.2714 16.6059 54.6933C16.6062 53.6017 15.7209 52.7166 14.6292 52.7166Z'
        fill='url(#paint35_linear_settings_manageChannels)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_settings_manageChannels'
          x1='61.9953'
          y1='22.4822'
          x2='61.9953'
          y2='82.4889'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_settings_manageChannels'
          x1='62.4982'
          y1='62.4871'
          x2='62.4982'
          y2='64.4873'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_settings_manageChannels'
          x1='62.4982'
          y1='72.4874'
          x2='62.4982'
          y2='74.4877'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_settings_manageChannels'
          x1='56.9977'
          y1='68.4877'
          x2='56.9977'
          y2='69.4877'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_settings_manageChannels'
          x1='66.996'
          y1='68.4877'
          x2='66.996'
          y2='69.4877'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_settings_manageChannels'
          x1='56.9977'
          y1='54.4854'
          x2='56.9977'
          y2='55.4854'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint6_linear_settings_manageChannels'
          x1='66.996'
          y1='54.4854'
          x2='66.996'
          y2='55.4854'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint7_linear_settings_manageChannels'
          x1='55.9947'
          y1='34.4835'
          x2='55.9947'
          y2='38.484'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint8_linear_settings_manageChannels'
          x1='55.9947'
          y1='34.4835'
          x2='55.9947'
          y2='38.484'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint9_linear_settings_manageChannels'
          x1='55.9947'
          y1='28.4829'
          x2='55.9947'
          y2='32.4834'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint10_linear_settings_manageChannels'
          x1='55.9947'
          y1='28.4829'
          x2='55.9947'
          y2='32.4834'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint11_linear_settings_manageChannels'
          x1='61.9953'
          y1='34.4835'
          x2='61.9953'
          y2='38.484'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint12_linear_settings_manageChannels'
          x1='61.9953'
          y1='34.4835'
          x2='61.9953'
          y2='38.484'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint13_linear_settings_manageChannels'
          x1='67.9961'
          y1='34.4835'
          x2='67.9961'
          y2='38.484'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint14_linear_settings_manageChannels'
          x1='67.9961'
          y1='34.4835'
          x2='67.9961'
          y2='38.484'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint15_linear_settings_manageChannels'
          x1='55.9947'
          y1='40.4843'
          x2='55.9947'
          y2='44.4847'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint16_linear_settings_manageChannels'
          x1='55.9947'
          y1='40.4843'
          x2='55.9947'
          y2='44.4847'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint17_linear_settings_manageChannels'
          x1='61.9953'
          y1='40.4843'
          x2='61.9953'
          y2='44.4847'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint18_linear_settings_manageChannels'
          x1='61.9953'
          y1='40.4843'
          x2='61.9953'
          y2='44.4847'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint19_linear_settings_manageChannels'
          x1='67.9961'
          y1='40.4843'
          x2='67.9961'
          y2='44.4847'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint20_linear_settings_manageChannels'
          x1='67.9961'
          y1='40.4843'
          x2='67.9961'
          y2='44.4847'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint21_linear_settings_manageChannels'
          x1='55.9947'
          y1='46.4849'
          x2='55.9947'
          y2='50.4853'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint22_linear_settings_manageChannels'
          x1='55.9947'
          y1='46.4849'
          x2='55.9947'
          y2='50.4853'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint23_linear_settings_manageChannels'
          x1='61.9953'
          y1='46.4849'
          x2='61.9953'
          y2='50.4853'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint24_linear_settings_manageChannels'
          x1='61.9953'
          y1='46.4849'
          x2='61.9953'
          y2='50.4853'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint25_linear_settings_manageChannels'
          x1='67.9961'
          y1='46.4849'
          x2='67.9961'
          y2='50.4853'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint26_linear_settings_manageChannels'
          x1='67.9961'
          y1='46.4849'
          x2='67.9961'
          y2='50.4853'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint27_linear_settings_manageChannels'
          x1='8.30296'
          y1='0'
          x2='8.30296'
          y2='16.6059'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint28_linear_settings_manageChannels'
          x1='8.30296'
          y1='23.1993'
          x2='8.30296'
          y2='39.8053'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint29_linear_settings_manageChannels'
          x1='30.4383'
          y1='33.7394'
          x2='30.4383'
          y2='37.6933'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint30_linear_settings_manageChannels'
          x1='30.4383'
          y1='25.3083'
          x2='30.4383'
          y2='29.2623'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint31_linear_settings_manageChannels'
          x1='28.3297'
          y1='56.9364'
          x2='28.3297'
          y2='60.8904'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint32_linear_settings_manageChannels'
          x1='30.4383'
          y1='48.5005'
          x2='30.4383'
          y2='52.4544'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint33_linear_settings_manageChannels'
          x1='39.9274'
          y1='10.5448'
          x2='39.9274'
          y2='14.4988'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint34_linear_settings_manageChannels'
          x1='35.7101'
          y1='2.11011'
          x2='35.7101'
          y2='6.06406'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint35_linear_settings_manageChannels'
          x1='8.30296'
          y1='46.3904'
          x2='8.30296'
          y2='62.9963'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
      </defs>
    </svg>
  );
}
